import { useState } from 'react';

import clsx from 'clsx';

import { Button } from '@/common/styleguide/atoms/Button/Button';

import styles from './seoLinkingBox.module.scss';
import SeoLinks from './seoLinks';

const SeoLinkingBox = () => {
  const [isColumnsExpanded, setIsColumnsExpanded] = useState(false);

  const toggleColumnsVisibility = () => {
    setIsColumnsExpanded(!isColumnsExpanded);
  };

  return (
    <section className={styles.container} data-testid="SeoLinkingBox">
      <h2 className={styles.header}>Explore popular searches</h2>
      <div className={clsx(styles.columns, isColumnsExpanded && styles.expanded)}>
        {SeoLinks.map((seoColumn) => {
          return (
            <div className={styles.singleColumn} key={seoColumn.name}>
              <h3 className={styles.columnHeader}>{seoColumn.name}</h3>
              <ul className={styles.columnList}>
                {seoColumn.values.map((element) => (
                  <li className={styles.columnListElement} key={element.name}>
                    <h3 className={styles.element}>
                      <a className={styles.link} href={element.link.route}>
                        {element.name}
                      </a>
                    </h3>
                  </li>
                ))}
              </ul>
            </div>
          );
        })}
      </div>
      <div>
        <Button onClick={toggleColumnsVisibility} variant="text">
          {!isColumnsExpanded ? 'Show more' : 'Hide'}
        </Button>
      </div>
    </section>
  );
};

export default SeoLinkingBox;
